import { useQuery } from 'react-query';
import { axios } from '@/lib/axios';
import { useNotificationStore } from '@/stores/notifications';
import { API_URL } from '@/config';
import storage from '@/utils/storage';

export const getVolumeId = async (): Promise<any> => {
  const access_token = storage.getToken();

  if (!access_token) {
    return;
  }

  try {
    const volumes_list = await axios.get(`${API_URL}/v1/volume/volumes`);

    return volumes_list;
  } catch (error) {
    // throw error;
  }
};

export const useGetVolumeId = (config = {}) => {
  const { addNotification } = useNotificationStore();

  return useQuery<any, Error>({
    queryKey: ['volumeId'],
    queryFn: () => getVolumeId(),
    onError: (error) => {
      addNotification({
        type: 'error',
        title: 'Error fetching volume id!',
        message: error.message,
      });
    },
    onSuccess: (data) => {
      // Handle success here if needed
    },
    ...config,
  });
};
